import React, { useEffect, useRef, useState } from 'react';
import './SpeakersSection.css';
import maitrayeeImg from '../../assets/speakers_imgs/maitrayee.jpeg';
import harinieImg from '../../assets/speakers_imgs/harinie.jpeg';
import bhavnaImg from '../../assets/speakers_imgs/bhavna.jpeg';
import abhijeetImg from '../../assets/speakers_imgs/abhijeet.jpeg';
import sairamImg from '../../assets/speakers_imgs/sairam.jpeg';
import triguneshImg from '../../assets/speakers_imgs/trigunesh.jpeg';
import sparshImg from '../../assets/speakers_imgs/sparsh.png';
import salmaanImg from '../../assets/speakers_imgs/salmaan.jpeg';
// --- DATA ---
const SPEAKERS = [
  {name:"Dr. Maittrayee Patar", title:"Musical artist, Poet and Sociologist ", img: maitrayeeImg, bio:"Dr. Maittrayee Patar is an Indian musical artist, poet, and sociologist from Assam’s Tiwa community. Known for blending Assamese folk traditions with modern, new-age music, she co-founded the independent collective Project Baartalaap with Shankuraj Konwar. A classically trained vocalist, her music has gained international recognition and has been featured on platforms like Rolling Stone India. Alongside her artistic career, she holds a PhD in Sociology from Tezpur University and is the author of acclaimed poetry collections that explore themes of nature, identity, and womanhood."},
  {name:"Ms. Harinie Jeevitha", title:"Bharatanatyam Dancer & Choreographer", img: harinieImg, bio:"Harinie Jeevitha is an acclaimed Bharatanatyam dancer and choreographer, honored with the Bal Shree Award, India’s highest national recognition for young achievers in performing arts. A senior disciple of Dr. Sheela Unnikrishnan, she is a leading exponent of the Melattur style and an “A” grade artiste of Doordarshan. Her distinguished career includes original choreographic productions, national accolades, and performances on prestigious platforms. She also holds a master’s degree in Bharatanatyam and is a published poet."},
  {name:"Ms. Bhavna Harchandrai", title:"Fitness Expert & Wellness Entrepreneur", img: bhavnaImg, bio:"Bhavna Harchandrai is a veteran fitness professional and wellness entrepreneur with nearly 30 years of experience. She is the founder of Fitness Fundas and a pioneer in bringing global fitness trends like Boot Camp and Trampoline Fitness to India. An internationally certified ACE trainer, she is also the author of the bestselling book 5 Fingers of Fitness. A TEDx speaker, she advocates a holistic approach to health, integrating physical fitness, nutrition, and mental well-being."},
  {name:"Mr. Abhijeet Anand", title:"Founder & CEO, abCoffee", img: abhijeetImg, bio:"Abhijeet Anand is the founder and CEO of abCoffee, a fast-growing specialty coffee chain focused on making high-quality coffee accessible and affordable in India. An IIT (ISM) Dhanbad alumnus, he transitioned from a successful career at Schlumberger to entrepreneurship after recognizing a gap in India’s coffee market. Under his leadership, abCoffee has expanded rapidly and secured significant funding. He is also the founder of the Sarthak Mentoring Foundation, supporting skill development for underprivileged youth."},
  {name:"Dr. Sairam Atluri", title:"Physician & Regenerative Medicine Pioneer", img: sairamImg, bio:"Dr. Sairam Atluri is a globally recognized physician and pioneer in regenerative medicine and interventional pain management. With over three decades of medical experience, he is the founder of StemCures and Tulsi Therapeutics. He has led groundbreaking research, including the first clinical trial proving the effectiveness of stem cell therapy for chronic back pain. His current mission focuses on bringing affordable regenerative healthcare solutions to India."},
  {name:"Mr. Trigunesh Mukherjee", title:"Leadership Mentor & Founder, inme", img: triguneshImg, bio:"Trigunesh Mukherjee is a retired Indian Army officer and the founder of inme, an experiential learning organization dedicated to developing leadership and life skills among students. Drawing from his military experience, he designs nature-based leadership camps and mentoring programs that emphasize teamwork, resilience, and personal growth. He continues to serve as a mentor and advisor to young professionals and educators."},
  {name:"Dr. Sparsh Johari", title:"Assistant Professor", img: sparshImg, bio:"Dr. Sparsh Johari is an Assistant Professor of Civil Engineering at IIT Guwahati and an adjunct faculty member at the School of Business. His research focuses on construction project management, labor productivity, and workforce development. A PhD graduate from IIT Delhi, he has published extensively and received multiple awards for impactful research in construction management and skill development."},
  {name:"Mr. Salmaan Ahmed", title:"Student Designer ", img: salmaanImg, bio:"Salmaan Ahmed is a student designer from IIT Guwahati and the winner of the Unrestricted 2026 competition, earning the opportunity to speak at TEDxIITGuwahati. Passionate about creativity and innovation, he represents the power of student voices and ideas. His journey reflects the intersection of design thinking, storytelling, and youth-driven impact.."},
   
];


export default function SpeakersSection() {
  const cylinderContainerRef = useRef(null); 
  const cylinderRef = useRef(null);
  const cardsRef = useRef([]);
  
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPanelVisible, setIsPanelVisible] = useState(true);

  // Constants
  const N = SPEAKERS.length;
  const DEG_PER = 360 / N;
  const CARD_W = 260; 
  const GAP = 10;
  const RADIUS = ((CARD_W + GAP) * N) / (2 * Math.PI);

  const physics = useRef({
    rotationY: 0,
    velocity: 0,
    isDragging: false,
    startX: 0,
    lastFrontIndex: -1
  });

  useEffect(() => {
    // 1. Initial Layout
    if (cardsRef.current.length > 0) {
      cardsRef.current.forEach((card, i) => {
        if (!card) return;
        const angle = i * DEG_PER;
        const baseTransform = `rotateY(${angle}deg) translateZ(${RADIUS}px)`;
        card.style.setProperty('--base', baseTransform);
      });
    }

    // 2. Animation Loop
    let animationFrameId;
    const animate = () => {
      const state = physics.current;
      state.velocity *= 0.95; 
      state.rotationY += state.velocity;
      
      if (cylinderRef.current) {
        cylinderRef.current.style.transform = `translate3d(0, 0, 0) rotateY(${state.rotationY}deg)`;
      }

      const normalized = ((-state.rotationY % 360) + 360) % 360;
      const idx = Math.round(normalized / DEG_PER) % N;
      const frontIndex = (idx + N) % N;

      if (frontIndex !== state.lastFrontIndex) {
        state.lastFrontIndex = frontIndex;
        cardsRef.current.forEach((c, j) => {
           if(c) {
             if (j === frontIndex) c.classList.add('front');
             else c.classList.remove('front');
           }
        });
        setActiveIndex(frontIndex);
      }
      animationFrameId = requestAnimationFrame(animate);
    };
    animationFrameId = requestAnimationFrame(animate);

    // 3. Event Listeners
    const container = cylinderContainerRef.current;
    
    const handleDown = (e) => {
      physics.current.isDragging = true;
      physics.current.startX = e.clientX;
      if(container) container.setPointerCapture(e.pointerId);
    };

    const handleMove = (e) => {
      if (!physics.current.isDragging) return;
      const dx = e.clientX - physics.current.startX;
      physics.current.startX = e.clientX;
      physics.current.rotationY += dx * 0.25;
      physics.current.velocity = dx * 0.15;
    };

    const handleUp = () => {
      physics.current.isDragging = false;
    };

    const handleWheel = (e) => {
      e.preventDefault(); 
      const delta = (e.deltaY || e.deltaX);
      physics.current.rotationY -= delta * 0.25;
      physics.current.velocity = -delta * 0.15;
    };

    if (container) {
      container.addEventListener("pointerdown", handleDown);
      container.addEventListener("pointermove", handleMove);
      container.addEventListener("pointerup", handleUp);
      container.addEventListener("pointercancel", handleUp);
      container.addEventListener("wheel", handleWheel, { passive: false });
    }

    return () => {
      cancelAnimationFrame(animationFrameId);
      if (container) {
        container.removeEventListener("pointerdown", handleDown);
        container.removeEventListener("pointermove", handleMove);
        container.removeEventListener("pointerup", handleUp);
        container.removeEventListener("pointercancel", handleUp);
        container.removeEventListener("wheel", handleWheel);
      }
    };
  }, [DEG_PER, N, RADIUS]);

  const handleCardClick = (index, e) => {
    e.stopPropagation();
    const target = -index * DEG_PER;
    const start = physics.current.rotationY;
    const duration = 550;
    const startTime = performance.now();

    const animateClick = (currentTime) => {
      const elapsed = currentTime - startTime;
      const t = Math.min(elapsed / duration, 1);
      const ease = 1 - Math.pow(1 - t, 3);
      physics.current.rotationY = start + (target - start) * ease;
      if (t < 1) requestAnimationFrame(animateClick);
    };
    requestAnimationFrame(animateClick);
  };

  const activeSpeaker = SPEAKERS[activeIndex];

  return (
    <div className="speakers-section-container">
      <div className="speakers-header">
        <h1 className="section-title">
          OUR <span className="highlight">SPEAKERS</span>
        </h1>
        <div className="section-subtitle">Voices that inspire</div>
      </div>

      <div className="cylinder-layout">
        <div className="cylinder-left" ref={cylinderContainerRef}>
          <div className="cylinder-stage">
            <div className="cylinder-viewport">
              <div className="cylinder-obj" ref={cylinderRef}>
                {SPEAKERS.map((speaker, i) => (
                  <div
                    key={i}
                    className="cyl-card"
                    ref={(el) => (cardsRef.current[i] = el)}
                    onClick={(e) => handleCardClick(i, e)}
                  >
                    <div 
                      className="cyl-photo" 
                      style={{ backgroundImage: `url(${speaker.img})` }} 
                    />
                    <div className="cyl-meta">
                      <div className="cyl-name">{speaker.name}</div>
                      <div className="cyl-title">{speaker.title}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="cyl-hint">Scroll or drag to rotate</div>
          </div>
        </div>

        <div className="cylinder-right">
          <aside className={`info-panel ${!isPanelVisible ? 'hidden' : ''}`}>
             {/* <button className="info-close" onClick={() => setIsPanelVisible(!isPanelVisible)}>
               {isPanelVisible ? '✕' : '+'}
             </button> */}

             {/* HEADER: Badge, Name, Title (Left) + Photo (Right) */}
             <div className="info-header-container">
                <div className="info-text-group">
                   {/* MOVED BADGE HERE to top of text */}
                   <div className="info-badge">Speaker</div> 
                   
                   <h2 className="info-name-large">{activeSpeaker.name}</h2>
                   <div className="info-title-large">{activeSpeaker.title}</div>
                </div>
                
                <div 
                  className="info-photo-right" 
                  style={{ backgroundImage: `url(${activeSpeaker.img})` }} 
                />
             </div>

             <div className="info-divider" />

             {/* BODY: Scrollable Text */}
             <div className="info-body">
               {activeSpeaker.bio}
             </div>
          </aside>
        </div>
      </div>
    </div>
  );
}